import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-journey',
  templateUrl: './report-journey.component.html',
  styleUrls: ['./report-journey.component.css']
})
export class ReportJourneyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
